import { useTranslate } from "@similarweb/i18n-provider";
import { Salesloft } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type SalesloftReconnectPanelProps = {
    onConnect: () => void;
    dataAutomation?: string;
};

export const SalesloftReconnectPanel = ({
    onConnect,
    dataAutomation = "salesloft-reconnect-panel",
}: SalesloftReconnectPanelProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="8px"
            maxWidth="440px"
            padding="20px 24px"
            alignItems="stretch"
            borderRadius="10px"
            border={`1px solid ${colorsPalettes.midnight["50"]}`}
            data-automation={dataAutomation}
        >
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon["500"]}
                data-automation={`${dataAutomation}-title`}
            >
                {translate("si.salesloft.reconnect-panel.title")}
            </Text>
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon["300"]}
                data-automation={`${dataAutomation}-subtitle`}
            >
                {translate("si.salesloft.reconnect-panel.subtitle")}
            </Text>
            <Stack gap="12px">
                <Flex
                    alignItems="center"
                    gap="8px"
                    margin="8px 0 0"
                >
                    <Salesloft
                        size="xl"
                        color={colorsPalettes.carbon["500"]}
                    />
                    <Text
                        fontVariant="h6"
                        color={colorsPalettes.carbon["500"]}
                    >
                        Salesloft
                    </Text>
                </Flex>
                <Button
                    type="primary"
                    onClick={onConnect}
                    dataAutomation={`${dataAutomation}-connect`}
                >
                    {translate("si.salesloft.reconnect-panel.connect-button")}
                </Button>
                <Text
                    fontVariant="dataTable2"
                    color={colorsPalettes.carbon["300"]}
                    textAlign="center"
                    data-automation={`${dataAutomation}-caption`}
                >
                    {translate("si.salesloft.reconnect-panel.caption")}
                </Text>
            </Stack>
        </Stack>
    );
};
